/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Green
 *
 * 1 = Yellow
 *
 * 2 = Red
 */
export enum SoHeaderTrackerStatusColorEnum {
  Green = 0,
  Yellow = 1,
  Red = 2,
}
